var CheckOutPath = "CheckOut";
var CheckOutAddressPath = "CheckOutAddress";
var CheckOutValidator = "CheckoutValidation";
var CheckoutPayment = "CheckoutPayment";

var isSingleLineCreditCard = false;

function formatCC(value) {
    var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
    var matches = v.match(/\d{4,16}/g);
    var match = matches && matches[0] || ''
    var parts = []
    for (i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4))
    }
    if (parts.length) {
        return parts.join(' ')
    } else {
        return value
    }
}

function validateCardNumber(number) {
    var regex = new RegExp("^[0-9]{16}$");
    if (!regex.test(number))
        return false;

    return luhnCheck(number);
}

function luhnCheck(val) {
    var sum = 0;
    for (var i = 0; i < val.length; i++) {
        var intVal = parseInt(val.substr(i, 1));
        if (i % 2 == 0) {
            intVal *= 2;
            if (intVal > 9) {
                intVal = 1 + (intVal % 10);
            }
        }

        sum += intVal;
    }

    return (sum % 10) == 0;
}

function IsNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function GiftPackage() {
    //hediye paketi kontrolü yap

    var wantGift = $(".OrderRadio #GiftPackageChk").prop("checked");

    if (wantGift != null && wantGift != "" && wantGift != undefined && (typeof wantGift !== 'undefined')) {
        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutCart/SetGift?wantGift=" + wantGift,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    RefreshOrderSummary();

                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                    $("#GiftTable input").removeProp("checked");
                    $("#GiftTable input[value=" + selectedCargoPriceID + "]").prop("checked", "checked");
                }
            }
        });
    }
}

function ReloadOnTimeOut(dt) {

    if (dt != undefined) {

        //timeout no state found reload
        if (dt.StatusText == "CheckOutStateTimeOut" || dt.StatusText == "Reload") {

            $(".AjaxLoader").show();
            document.location.reload(true);
        }
    }
}

function ShowInstallmentByBankCode(BankCode, cardType, BankLogoPath) {

    var activeCls = $("#PaymentGroups .PaymentGroupItem.active:first input:first").attr("data-payment");

    $("#PosGroups .PosGroupItem").hide();

    switch (cardType) {

        case "Credit":
            if (activeCls != "KrediKarti") {

                AutoFillBankLogo = BankLogoPath;
                activeCls = "KrediKarti";

                $(".PaymentGroupSelectNew li").removeClass("active");
                $(".PaymentGroupSelectNew li a.KrediKarti").parent().addClass("active");
                $(".PaymentGroupSelectNew li a input").removeAttr("checked");
                $(".PaymentGroupSelectNew li a.KrediKarti input").attr("checked", "checked");
                $(".PaymentGroupSelectNew li a.KrediKarti input").trigger("change");

                if (BankLogoPath != undefined && BankLogoPath != "") {
                    $("div#CreditCardLogo > img").show();
                    $("div#CreditCardLogo > img").attr("src", "/ContentImages/Banks/" + BankLogoPath);
                }
            }
            break;
        case "Debit":
            if (activeCls != "KrediKarti") {

                AutoFillBankLogo = BankLogoPath;
                activeCls = "KrediKarti";

                $(".PaymentGroupSelectNew li").removeClass("active");
                $(".PaymentGroupSelectNew li a.KrediKarti").parent().addClass("active");
                $(".PaymentGroupSelectNew li a input").removeAttr("checked");
                $(".PaymentGroupSelectNew li a.KrediKarti input").attr("checked", "checked");
                $(".PaymentGroupSelectNew li a.KrediKarti input").trigger("change");

                if (BankLogoPath != undefined && BankLogoPath != "") {

                    $("div#CreditCardLogo > img").show();
                    $("div#CreditCardLogo > img").attr("src", "/ContentImages/Banks/" + BankLogoPath);
                }
            }

            //if (activeCls != "DebitCard") {
            //    AutoFillBankLogo = BankLogoPath;

            //    activeCls = "DebitCard";

            //    $(".PaymentGroupSelectNew li").removeClass("active");
            //    $(".PaymentGroupSelectNew li a.DebitCard").parent().addClass("active");

            //    $(".PaymentGroupSelectNew li a input").removeAttr("checked");
            //    $(".PaymentGroupSelectNew li a.DebitCard input").attr("checked", "checked");

            //    //Debite Geçiş
            //    $(".PaymentGroupSelectNew li a.DebitCard input").trigger("change");

            //    if (BankLogoPath != undefined && BankLogoPath != "") {

            //        $("div#CreditCardLogo > img").show();
            //        $("div#CreditCardLogo > img").attr("src", "/ContentImages/Banks/" + BankLogoPath);
            //    }
            //}
            break;
    }

    $(".Installments ul").hide();

    if (activeCls == "KrediKarti") {
        $(".Installments ul.InstallmentHeader").show();
    } else {
        $(".AllInstallments").hide();
        $("#PaymentBanners").hide();
    }

    // Banka kredi kartı title
    $(".Installments .BarInner span").hide();
    $(".Installments .BarInner span." + activeCls).show();

    var cardown = $("#CardOwner:first").val();

    // Amex ve ShopAndMiles Taksit gösterme, ama garantiden geç
    var isAmex = false;
    var isShopAndMiles = false;
    if (LastCardName.toUpperCase().indexOf("AMEX") > -1) isAmex = true;
    if (LastCardName.toUpperCase().indexOf("MASTER SM") > -1 || LastCardName.toUpperCase().indexOf("VISA SM") > -1) isShopAndMiles = true;
    if (isAmex || isShopAndMiles) BankCode = "62";

    // Banka koduna ait taksit seçeneği varsa
    if ($(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "']").length > 0 && cardown.toUpperCase() != "BÜTÜN POSLAR") {

        $("#PosGroups .PosGroupItem[data-rel='" + BankCode + "']").show();
        $("#PosGroups .PosGroupItem[data-rel='" + BankCode + "']").addClass("active");

        $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "']").show(); // İlgili kart türünün tüm taksitlerini kapsayan alanın gösterilmesi

        // Sadece kredi kartı ise tüm taksitler gösterilsin, banka kartlarına sadece tek taksit gösterilecek
        if (cardType != "Debit") {
            $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li").show();
        }
        else {
            $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li").hide();
            $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li.FirstInstallment").show();
        }

        // Pos başlık logo ile birlikte göster/gizle hide olduğunda sadece taksitler görünür.
        $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] .PosHeader").show();
        $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").attr("checked", "checked");
        $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").trigger("change");
        //$(".Installments ul.InstallmentHeader").show();

        if (isAmex || isShopAndMiles) {
            $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li").hide();
            $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li.FirstInstallment").show();
        }
    }
    else {
        // Banka koduna ait taksit seçeneği YOKSA tek çekim göster 
        if (cardown != "BÜTÜN POSLAR") {

            $("#PosGroups .PosGroupItem[data-webposid='other']").show();
            $("#PosGroups .PosGroupItem[data-webposid='other']").addClass("active");

            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li").hide();
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] .PosHeader").hide();
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "']:first").show();
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first").show();
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").attr("checked", "checked");
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").trigger("change");
            $(".Installments ul.InstallmentHeader").hide();
        }
        else {
            // Banka koduna ait taksit seçeneği YOKSA tüm taksitleri göster
            $(".Installments ul[data-cardtype='" + activeCls + "']").show();
            $(".Installments ul[data-cardtype='" + activeCls + "'] li").show();
            $(".Installments ul[data-cardtype='" + activeCls + "'] .PosHeader").show();
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").attr("checked", "checked");
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").trigger("change");
        }
    }
}

var firstBin = "";
var lastBin = "";
var AutoFillCard1 = "";
var AutoFillBankCode = "-1";
var AutoFillCard2 = "";
var AutoFillName = "";
var AutoFillBankLogo = "";
var LastCardName = "";

function CheckBinNumber(t, t_1, t_2) {

    var t_1 = $("#CardNumbers > input#CardNumber1").val().replace(/\D/g, '');
    var t_2 = $("#CardNumbers > input#CardNumber2").val().replace(/\D/g, '');
    var t_3 = $("#CardNumbers > input#CardNumber3").val().replace(/\D/g, '');
    var t_4 = $("#CardNumbers > input#CardNumber4").val().replace(/\D/g, '');

    var t = (t_1 + t_2);

    if (t.length >= 8 && (isSingleLineCreditCard || (t_1.length == 4 && t_2.length >= 4))) {

        var tval6 = t.substring(0, 8);
        lastBin = tval6;

        if (lastBin != firstBin) {

            $.ajax({
                url: "/" + CheckoutPayment + "/CardDetails",
                dataType: 'json',
                async: true,
                data: "BinNo=" + tval6,
                success: function (jsonReturn) {

                    if (jsonReturn.length !== 0) {

                        $.each(jsonReturn, function (index, element) {
                            var ax = (element.ID + "-");

                            $("div#CreditCardLogo > img").show();
                            $("div#CreditCardLogo > img").attr("src", "/ContentImages/Banks/" + element.BankLogoPath);

                            bnkCode = element.BankCode;
                            cardType = element.CardType;
                            AutoFillBankCode = bnkCode;
                            var LogoPath = element.BankLogoPath;

                            if (element.CardLogoPath != undefined && element.CardLogoPath.length > 0) {
                                LogoPath = element.BankLogoPath;
                            }

                            LastCardName = element.CardName;
                            ShowInstallmentByBankCode(bnkCode, cardType, LogoPath);
                        });
                    }
                    else {
                        bnkCode = "-1";
                        AutoFillBankCode = "-1";
                        ShowInstallmentByBankCode(bnkCode, -1, "");
                    }
                }
            });

            firstBin = lastBin;
        }
    }
}

function PrepareAddressAndPayment() {

    if ($("#CurStep").length > 0) {


        var step = $("#CurStep").val();

        var url = "";

        if (step == "Sepet") {
            url = "/" + $("#SmallLangCode").val() + "/p/CheckOutAddress/PrepareUserAdresses";
        }

        if (step == "Adres") {
            url = "/" + $("#SmallLangCode").val() + "/p/CheckOutPayment/PreparePayment";
        }

        if (url.length > 0) {
            $.ajax({
                type: 'post',
                url: url,
                success: function (dt) {

                }
            });
        }

    }
}

function SetPaymentType(webPosInstallmentID, BankID) {

    if (BankID == undefined) { BankID = 0; }

    $.ajax({
        type: 'post',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOutPayment/SetPaymentType?webPosInstallmentID=" + webPosInstallmentID + "&bankID=" + BankID,
        success: function (dt) {

            ReloadOnTimeOut(dt);

            if (dt.Status) {

                RefreshOrderSummary(false, false);

            } else {

                SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
            }
        }

    });

}

function ReloadPage() {
    $(".AjaxLoader").show();
    $(".container").css("opacity", "0.5");
    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + '/p/CheckOutCart/RemoveCoupon',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        success: function (dt) {

        }
    });
    document.location.reload(true);
}

function SetErrorResults(target, errors, clear, slideDown, isErrorString) {

    $('html,body').animate({ scrollTop: 0 }, 'slow', function () { });

    if (clear) {
        $(target).html("");
    }

    if (errors != undefined && errors.length > 0) {

        if (isErrorString === false) {

            for (var i = 0; i < errors.length; i++) {

                $(target).append(errors[i] + "<br />");
            }
        }
        else {
            $(target).append(errors + "<br />");
        }

        if (slideDown) {
            $(target).show();
        }
        else {
            $(target).show();
        }
    }
}

function GetAddressForm(url) {

    if ($("#AddressArea").length > 0) {

        $.ajax({
            type: "GET",
            cache: false,
            url: url,
            success: function (dt) {

                ReloadOnTimeOut(dt);
                $("#AddressArea").html(dt);
                HandleAddressInputs();

            }
        });

    }
}

function RefreshOrderSummary(animateTop, showCouponLine) {
    $.ajax({
        type: 'get',
        cache: false,
        url: "/" + $("#SmallLangCode").val() + "/p/" + CheckOutPath + "/summary",
        success: function (dt) {
            $("#OrderSummary").html(dt);
            RefreshBasketItems(); // Sepet güncellenince sol tarafta listelenen ürünlerin güncellenmesi için çağırılan fonksiyon

            if (showCouponLine) {
                $(".CouponLine").hide();
                $(".CouponLine").show("slow");

                if ($("#CouponModal").length > 0) {
                    $("#CouponModal").modal("hide");
                }
            }

            if (animateTop) {
                $('html,body').animate({ scrollTop: 100 }, 'slow', function () { });
            }
        }
    });
}

// Bu metod 'sepet' adımında ürün fiyatlarında değişiklik olduğunda listelenen ürünleri güncellemek için kullanılıyor
function RefreshBasketItems() { /*animateTop*/
    $.ajax({
        type: 'get',
        cache: false,
        url: "/" + $("#SmallLangCode").val() + "/p/" + CheckOutPath + "/sepetItems",
        success: function (dt) {
            GenerateLocalLoading($("#OrderBasket"), "hide");
            $("#OrderBasket").html(dt);
        }
    });
}

function RefreshCargoList() {

    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOutAddress/GetCargoList",
        success: function (dt) {
            $("#CargoList").html(dt);
        }

    });
}

function HandleAddressInputs() {

    if ($(".OrderAdressForm").length > 0) {

        //if ($(".OrderAdressForm #Phone2").length > 0) {

        //    //if ($(".OrderAdressForm #Phone2").val().length <= 0) {
        //    //    $(".OrderAdressForm #Phone2").val("0");
        //    //}

        //    $(".OrderAdressForm #Phone2").mask("999 999 99 99");
        //}
    }
}

function UseCoupon(couponCode, isComoCouponCode) {
    $.ajax({
        type: 'get',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOutCart/AddCoupon?couponCode=" + couponCode + "&isComoCouponCode=" + isComoCouponCode,
        success: function (dt) {

            ReloadOnTimeOut(dt);

            if (dt.Status == true) {
                //Sipariş özetini Yenile
                RefreshOrderSummary(true, true);

                if (isComoCouponCode == false) {
                    // Site taraflı kupon kullanılmış ise
                    $("#OrderCoupons tr").removeClass("added");
                    $("#OrderCoupons tr button[data-value=" + couponCode + "]").closest("tr").addClass("added");
                }
                else {
                    // Como taraflı kupon kullanılmış ise
                    $("#OrderCoupons tr").removeClass("added");
                    $("#OrderCoupons tr button[data-couponKey=" + couponCode + "]").closest("tr").addClass("added");
                }

                // Önceki denemelerden kalma hatalar temizleniyor
                $("#Erros").val("");
                $("#Erros").hide();
            }
            else {
                SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
            }
        }
    });
}

//Site taraflı ya da Como taraflı kuponları silmek için kullanılan ortak metod
function RemoveCoupon() {
    $.ajax({
        type: 'post',
        url: "/" + $("#SmallLangCode").val() + '/p/CheckOutCart/RemoveCoupon',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        success: function (dt) {
            if (dt.Sonuc == false) {
                SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
            } else {
                RefreshOrderSummary(false, false);
                $("#OrderCoupons tr").removeClass("added");
            }
        }
    });
}

function UpdateCartAmount(BasketID, Amount, LangID, callback) {
    $.ajax({
        type: 'GET',
        url: '/' + $("#SmallLangCode").val() + '/p/Cart/UpdateCartAmount',
        data: 'id=' + BasketID + "&adet=" + Amount + "&langID=" + LangID,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        cahce: false,
        async: true,
        success: function (dt) {
            callback(dt);
        },
        error: function () {
            callback(null);
        }
    });
}

function RemoveFromCart(BasketID, LangID, RemoveAll, callback) {
    $.ajax({
        type: 'GET',
        url: '/' + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
        data: 'id=' + BasketID + "&langID=" + 1 + "&RemoveAll=" + RemoveAll,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        success: function (dt) {
            callback(dt);
        },
        error: function () {
            callback(null);
        }
    });
}

function SetCreditCartAndStep(adim, href) {

    if ($("#CardForm").length > 0) {

        $form = $("#CardForm");

        $.ajax({
            type: 'post',
            async: true,
            cache: false,
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/SetCreditCard",
            data: $form.serialize(),
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    SetStep(adim, href);
                    //Sipariş özetini Yenile
                    //RefreshOrderSummary(true, true); 
                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                }
            }
        });
    }
}

function SetStep(adim, href) {

    var OrdGiftNote = "";

    if ($("#OrderNoteText").length > 0) {

        OrdGiftNote += "OrderNote=" + $("#OrderNoteText").val();
    }

    if ($("#OrderGiftNoteText").length > 0) {
        OrdGiftNote += "&GiftNote=" + $("#OrderGiftNoteText").val();
    }

    $.ajax({
        type: 'POST',
        cache: false,
        url: "/" + SmallLangCode + "/p/" + CheckOutValidator + "/SetStep?step=" + adim,
        data: OrdGiftNote,
        success: function (dt) {

            ReloadOnTimeOut(dt);

            if (dt.Status == false) {

                //ask for login or memberless
                if (dt.StatusText == "AskForLogin") {

                    $("#LoginRegisterModal").modal("show");
                }

                //Edit Address Or Create Address
                if ($("#AddressArea").length > 0 && (dt.StatusText == "MissingAddress" || dt.StatusText == "InvalidAddress")) {

                    //$('.ModifyIcon').data('id') seçili olan adresi getirsin diye yapılan işlem
                    var url = "/" + $("#SmallLangCode").val() + "/p/" + CheckOutAddressPath + "/EditOrCreate?id=" + $('.ModifyIcon').data('id');

                    GetAddressForm(url);

                } else if (dt.Status == false) {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                }

            }

            if (dt.Status == true) {

                $("#Steps > button, #nextbtn, .Bottom #nextbtn, #backbutton, .Bottom #backbutton").attr("disabled", "disabled");

                //hata yoksa ve progress ise bekleyinizi göster
                if (adim == "progress") {

                    $("#nextbtn, .Bottom #nextbtn, #backbutton,  .Bottom #backbutton").text($("#PleaseWait").val());

                    $(".AjaxLoaderDiv").css("left", "44%");

                }

                //goto next step
                document.location.href = "/" + SmallLangCode + "/p/" + CheckOutPath + "/" + adim;

            }
        }
    });
}

function ToggleAgreements() {
    $(".AgreementHeader").on("click", function () {
        $(this).next(".toggle").slideToggle();
        $(this).find("i").toggleClass("minus-icon");

    });
}

function GetUserMember() {

    if (($("body").hasClass("sepet"))) { //|| $("body").hasClass("odeme")) && !$("body").hasClass("adres")) {

        $.ajax({
            type: 'POST',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutCart/GetMemberUserGroup",
            success: function (dt) {

                //console.log(dt);
                //ReloadOnTimeOut(dt);
                window.dt = dt;

                if (dt.messages != null && dt.messages.length > 0) {
                    console.log(dt.messages)
                    $(".CampaignAlert").html(
                        dt.messages.map(function (item) {
                            console.log(item);
                            return "<div class='messageItem'>" + item + "</div>";
                        })
                    );

                    //$("#CampaignModal").modal();
                }
                else {
                    //console.log(dt);
                }
            }
        });
    }
}

function AddToFavoriteNewCheckout(ProductID, ColorID) {

    if (ColorID != undefined && ProductID != undefined) {

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToFollowList",
            data: 'colorID=' + ColorID + "&productID=" + ProductID,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.Sonuc == true) {

                    //#region Related Datalayer Add To Favorite Operation
                    if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                        window.dataLayer.push(JSON.parse(dt.Deger8));
                    }
                    //#endregion
                }
                else if (dt.Sonuc == false) {
                    alert('Favorilere eklemek için giriş yapınız!');
                }
            },
            error: function (httpObj, textStatus) {


                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');

            }
        });
    }

}

// Como işlemlerinde bilgilendirme modal'ını içeriğinin düzenlenmesini sağlayan fonksiyon.
// Kullanıcı kuponu seçtikten sonra değiştirme yapamayacak ve seçilen bu kupon kullanılması gerekecek,
// eğer kupon kullanılmaktan vazgeçilirse ve kullanılmazsa belirli bir süre tekrardan seçilemeyecek şekilde kalmaktadır(Como tarafında).
function SetComoModalValues(element) {
    var modelDescription = $(element).attr("data-modal-description"); // Modal'da gösterilecek olan açıklamanın alınması
    $("#ComoCouponModal .modal-body").html(modelDescription); // Modal'a açıklamının basılması

    $("#ComoCouponModal #UseComoCouponId").hide();
    $("#ComoCouponModal .RemoveComoCoupon").show();
}

//#region Como Para-Puan 

// Como taraflı 'para-puan' kullanmak için çağrılan fonksiyon 
function UseComoMoneyPoints(amountValue) {
    var moneyPointsAmount = 0;
    if (amountValue !== undefined && amountValue !== null && $.isNumeric(amountValue)) {
        moneyPointsAmount = amountValue;
    }
    else {
        moneyPointsAmount = $("#ComoMoneyPointsInput").val(); // para-puan alanına girilen değer alınıyor
    }

    $.ajax({
        type: 'get',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOutCart/AddComoMoneyPoints?moneyPointsAmount=" + moneyPointsAmount,
        success: function (dt) {

            ReloadOnTimeOut(dt);

            if (dt.Status == true) {
                RefreshOrderSummary(true, true);  //Sipariş özetini Yenile

                // Önceki denemelerden kalma hatalar temizleniyor
                $("#ComoMoneyPointsUsageErrors").val("");
                $("#ComoMoneyPointsUsageErrors").attr("display", "none");
            }
            else {
                SetErrorResults($("#ComoMoneyPointsUsageErrors"), dt.ResultDescription, true, true);
            }
        }
    });

    e.preventDefault();
    return false;
}

//#endregion

/// <summary>Generate Loading Overlay</summary>
/// <param name="ParentElement">loading container element</param>
/// <param name="operation">show or hide</param>
function GenerateLocalLoading(ParentElement, operation) {
    var AddingOverlayHtml = '<div class="loading-overlay"><i class="button-loader"></i></div>';

    if (operation == "show") {
        if (ParentElement.find("loading-overlay").length == 0) {
            ParentElement.append(AddingOverlayHtml);
        }
    }
    else if (operation == "hide") {
        ParentElement.find(".loading-overlay").remove();
    }
}

/// Kupon ekleme inputunun summary alanına taşınması sonrası
/// Açılır menü kontrolü
function CouponAreaToggle() {
    $(document).on("click", ".SummaryContainer .OrderCouponCodes .MainHead", function () {
        $(this).find("h1").toggleClass("open");
        $(".SummaryContainer .OrderCouponCodes > .row").slideToggle();
    });
}

//#region JKMoneyPuan Functions

/// JK ParaPuan ekleme inputunun summary alanına taşınması sonrası açılır menü kontrolü
function JKMoneyPuanAreaToggle() {
    $(document).on("click", ".SummaryContainer .OrderJKMoneyPuan .MainHead", function () {
        $(this).find("h1").toggleClass("open");
        $(".SummaryContainer .OrderJKMoneyPuan > .row").slideToggle();
    });
}

function UseJKMoneyPuan(JKMoneyPuanAmount) {
    $.ajax({
        type: 'get',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOutCart/AddJKMoneyPuan?jKMoneyPuanAmount=" + JKMoneyPuanAmount,
        success: function (dt) {

            ReloadOnTimeOut(dt);

            if (dt.Status == true) {

                // Eğer ödeme adımındaysa taksit kısmındaki ödeme tutarının güncellenmesi için sayfa tazelenecek değilse sadeec sipariş özeti kısmı güncellenecek
                if (window.location.href.includes('odeme')) {
                    window.location.reload();
                }
                else {
                    // Önceki denemelerden kalma hatalar temizleniyor
                    $("#Erros").val("");
                    $("#Erros").hide();

                    // Sipariş özetini Yenile
                    RefreshOrderSummary(true, true);
                }
            }
            else {
                SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
            }
        }
    });
}

// Site taraflı ya da Como taraflı kuponları silmek için kullanılan ortak metod
function RemoveJKMoneyPuan() {
    $.ajax({
        type: 'post',
        url: "/" + $("#SmallLangCode").val() + '/p/CheckOutCart/RemoveJKMoneyPuan',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        success: function (dt) {
            if (dt.Sonuc == false) {
                SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
            } else {
                if (window.location.href.includes('odeme')) {
                    window.location.reload();
                }
                else {
                    RefreshOrderSummary(false, false);
                    //$("#OrderCoupons tr").removeClass("added");
                }
            }
        }
    });
}

//#endregion JKMoneyPuan Functions

$(document).ready(function () {

    PrepareAddressAndPayment();
    ToggleAgreements();
    AddToFavoriteNewCheckout();
    GetUserMember();
    CouponAreaToggle();
    JKMoneyPuanAreaToggle();

    if ($(".SingleLineCart").length > 0) {
        isSingleLineCreditCard = true;
    }

    $("#PaymentWith3D").on('click', function () {
        if ($(this).val() == 1) {
            $(this).val(0);
        }
        else {
            $(this).val(1);
        }
    });

    //SetStep Validate and Navigate
    $("body").on("click", "#Steps > button, #nextbtn, #backbtn", function () {

        var adim = $(this).attr("data-next");
        var href = $(this).attr("data-href");

        if (href != undefined && href != "") {
            document.location.href = href;
            return;
        }

        if ($(".PaymentDetail.KrediKarti").hasClass("active") && adim == "progress") {
            SetCreditCartAndStep(adim, href);

        }
        else if ($(".PaymentDetail.MasterPass").hasClass("active") && adim == "progress") {
            masterpass.SetMasterPassCartAndStep();
        }
        else {
            SetStep(adim, href);
        }
    });

    $("#LoginRegisterModal").on("click", ".ContinueWithoutMember", function (e) {

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/" + CheckOutValidator + "/SetMemberless?memberless=true",
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    //SetStep(adim, href);
                    //Sipariş özetini Yenile
                    //RefreshOrderSummary(true, true); 
                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                }

            }

        });

        return false;
        e.preventDefault();

    });

    //Cart Change Delete 
    $(document).on("keyup", "input.sepetAdet", function () {
        var updateID = $(this).attr("data-id");
        var yeniAdet = $(this).val();
        var adetKutusu = $(this);
        var LangID = $("#LangID").val();

        if (yeniAdet <= 1) {
            $(adetKutusu).val(1);
        }
        else if (yeniAdet >= 9) {
            $(adetKutusu).val(9);
        }

        //update'den Sonra
        var sepetToplami = 0;

        var ToplamAdet = $("#ustSepetAdet").html();

        var guncellenecekContainerObje = $(this).parent().parent();

        $(guncellenecekContainerObje).find(".ustSepetAjaxLoader").show();
        $(guncellenecekContainerObje).find(".ustSepetDelete").hide();

        $(guncellenecekContainerObje).css("opacity", "0.5");

        $.ajax({
            type: 'get',
            url: '/Cart/UpdateCartAmount',
            data: 'id=' + updateID + "&adet=" + yeniAdet + "&langID=" + LangID,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            cahce: false,
            success: function (dt) {

                GiftPackage();

                if (dt.Sonuc == true) {

                    //#region Related Datalayer change product count Operation
                    if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                        window.dataLayer.push(JSON.parse(dt.Deger8));
                    }
                    //#endregion

                    ReloadPage();
                }
                else {
                    alert(dt.IslemSonucAciklama);
                }

                $(guncellenecekContainerObje).find(".ustSepetAjaxLoader").hide();
                $(guncellenecekContainerObje).find(".ustSepetDelete").show();
                $(guncellenecekContainerObje).css("opacity", "1");
            }
        });

        // ISNUMERIC ADET SONU
    });

    // Amount Option Change
    $(document).on("click", ".BasketDetails .GenMinus, .BasketDetails .GenPlus", function () {
        $SepetAdet = $(this).closest(".BasketDetails").find("input.sepetAdet");
        var basketID = $SepetAdet.attr("data-id");
        var LangID = $("#LangID").val();

        $("#Erros").html("");
        $("#Erros").hide();

        GenerateLocalLoading($("#OrderBasket"), "show");

        if ($(this).hasClass("GenPlus") == true) {

            $SepetAdet.val(parseInt($SepetAdet.val()) + 1);
            UpdateCartAmount(basketID, $SepetAdet.val(), LangID, function (dt) {
                if (dt == null) {
                    SetErrorResults($("#Erros"), "İstek boş geldi", true, true, true);
                    GenerateLocalLoading($("#OrderBasket"), "hide");
                    $SepetAdet.val(parseInt($SepetAdet.val()) - 1);
                }
                else if (dt.Sonuc == true) {
                    RefreshOrderSummary();
                }
                else {
                    SetErrorResults($("#Erros"), dt.IslemSonucAciklama, true, true, true);
                    GenerateLocalLoading($("#OrderBasket"), "hide");
                    $SepetAdet.val(parseInt($SepetAdet.val()) - 1);
                }
            });
        }
        else {
            $SepetAdet.val(parseInt($SepetAdet.val()) - 1);
            RemoveFromCart(basketID, $SepetAdet.val(), LangID, function (dt) {
                if (dt == null) {
                    SetErrorResults($("#Erros"), "İstek boş geldi", true, true);
                    GenerateLocalLoading($("#OrderBasket"), "hide");
                    $SepetAdet.val(parseInt($SepetAdet.val()) + 1);
                }
                else if (dt.Sonuc == true) {
                    RefreshOrderSummary();
                }
                else {
                    GenerateLocalLoading($("#OrderBasket"), "hide");
                    SetErrorResults($("#Erros"), dt.IslemSonucAciklama, true, true, true);
                    $SepetAdet.val(parseInt($SepetAdet.val()) + 1);
                }
            });
        }
    });

    $(document).on("click", "#OrderBasket .RemoveIcon", function () {

        var Silid = $(this).attr("data-id").replace("sepetsil", "");
        var pid = $(this).attr("data-productid");
        var LangID = $("#LangID").val();
        var ColorID = $(this).attr("data-colorsid");

        $("#DeleteAndAddFavorite").find("#deleteCart").attr("data-id", Silid);
        $("#DeleteAndAddFavorite").find("#addFavorite").attr("data-id", pid);
        $("#DeleteAndAddFavorite").find("#deleteCart").attr("data-langid", LangID);
        $("#DeleteAndAddFavorite").find("#addFavorite").attr("data-langid", LangID);
        $("#DeleteAndAddFavorite").find("#addFavorite").attr("data-colorid", ColorID);

        $('#DeleteAndAddFavorite').modal("show");

        $(document).on("click", "#DeleteAndAddFavorite .deleteCart", function () {
            var sil = $(this).attr("data-id");
            var dil = $(this).attr("data-langid");
            $(this).closest("tr").css("opacity", "0.5");

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
                data: 'id=' + Silid + "&langID=" + LangID + "&RemoveAll=" + true,
                contentType: "application/json; charset=utf-8",
                dataType: 'json',
                success: function (dt) {
                    //ReloadOnTimeOut(dt);

                    GiftPackage();

                    if (dt.Sonuc == false) {
                        SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                    } else {

                        //#region Related Datalayer Add To Basket Operation
                        if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                            window.dataLayer.push(JSON.parse(dt.Deger8));
                        }

                        //#endregion

                        //#region Checkot sayfasında sepetten ürün silindiğinde tüm sayfayı yenilemeden sepetteki ürünleri güncellemek için yapılanlar
                        //$.ajax({
                        //    type: 'get',
                        //    url: "/" + $("#SmallLangCode").val() + '/p/Checkout/sepetItems',
                        //    contentType: "application/json; charset=utf-8",
                        //    dataType: 'Html',
                        //    success: function (sepetItemsView) {
                        //        if (sepetItemsView !== undefined && sepetItemsView !== null) {
                        //            //console.log("Checkout/sepetItems isteği sonucu");
                        //            //console.log(sepetItemsView); 
                        //            $("#OrderBasket").html(sepetItemsView);
                        //        } else {
                        //            console.log("Checkout/sepetItems isteği hata alındı");
                        //        }
                        //    }
                        //});
                        //#endregion
                        ReloadPage();
                    }
                }
            });

        });

        $(document).on("click", "#DeleteAndAddFavorite .addFavorite", function () {
            var sil = $(this).attr("data-id");
            var dil = $(this).attr("data-langid");
            var renk = $(this).attr("data-colorsid");
            $(this).closest("tr").css("opacity", "0.5");
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
                data: 'id=' + Silid + "&langID=" + LangID + "&RemoveAll=" + true,
                contentType: "application/json; charset=utf-8",
                dataType: 'json',
                success: function (dt) {
                    //ReloadOnTimeOut(dt);

                    GiftPackage();

                    if (dt.Sonuc == false) {
                        SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                    } else {

                        //#region Related Datalayer Add To Basket Operation
                        if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                            window.dataLayer.push(JSON.parse(dt.Deger8));
                        }

                        //#endregion

                        //#region Checkot sayfasında sepetten ürün silindiğinde tüm sayfayı yenilemeden sepetteki ürünleri güncellemek için yapılanlar
                        //$.ajax({
                        //    type: 'get',
                        //    url: "/" + $("#SmallLangCode").val() + '/p/Checkout/sepetItems',
                        //    contentType: "application/json; charset=utf-8",
                        //    dataType: 'Html',
                        //    success: function (sepetItemsView) {
                        //        if (sepetItemsView !== undefined && sepetItemsView !== null) {
                        //            //console.log("Checkout/sepetItems isteği sonucu");
                        //            //console.log(sepetItemsView); 
                        //            $("#OrderBasket").html(sepetItemsView);
                        //        } else {
                        //            console.log("Checkout/sepetItems isteği hata alındı");
                        //        }
                        //    }
                        //});
                        //#endregion
                        ReloadPage();
                    }
                }
            });

            AddToFavoriteNewCheckout(sil, ColorID);

        });

        if (1 == 2) {
            console.log("RemoveIcon Clicked!");
            var Silid = $(this).attr("data-id").replace("sepetsil", "");
            var LangID = $("#LangID").val();

            $(this).closest("tr").css("opacity", "0.5");

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
                data: 'id=' + Silid + "&langID=" + LangID + "&RemoveAll=" + true,
                contentType: "application/json; charset=utf-8",
                dataType: 'json',
                success: function (dt) {
                    //ReloadOnTimeOut(dt);

                    GiftPackage();

                    if (dt.Sonuc == false) {
                        SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                    } else {

                        //#region Related Datalayer Add To Basket Operation
                        if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                            window.dataLayer.push(JSON.parse(dt.Deger8));
                        }

                        //#endregion

                        //#region Checkot sayfasında sepetten ürün silindiğinde tüm sayfayı yenilemeden sepetteki ürünleri güncellemek için yapılanlar
                        //$.ajax({
                        //    type: 'get',
                        //    url: "/" + $("#SmallLangCode").val() + '/p/Checkout/sepetItems',
                        //    contentType: "application/json; charset=utf-8",
                        //    dataType: 'Html',
                        //    success: function (sepetItemsView) {
                        //        if (sepetItemsView !== undefined && sepetItemsView !== null) {
                        //            //console.log("Checkout/sepetItems isteği sonucu");
                        //            //console.log(sepetItemsView); 
                        //            $("#OrderBasket").html(sepetItemsView);
                        //        } else {
                        //            console.log("Checkout/sepetItems isteği hata alındı");
                        //        }
                        //    }
                        //});
                        //#endregion
                        ReloadPage();
                    }
                }
            });
        }

    });

    //#region COUPON Functions
    $(document).on("submit", ".SummaryContainer #CouponForm", function () {
        var couponCode = $(this).find("#CouponCodeInput").val();
        UseCoupon(couponCode, false); // 'false' ile Como kuponu olmadığı belirtilmiş oluyor

        return false;
    });

    $(document).on("click", "#OrderSummary .OrderCouponCodes.UsedCode button#RemoveCoupon", function () {
        RemoveCoupon();
    });

    // Site taraflı kupon kullanımı
    $("body .UsetCouponTd").click(function (e) {

        var couponCode = $(this).attr("data-value");
        UseCoupon(couponCode, false); // 'false' ile Como kuponu olmadığı belirtilmiş oluyor

        e.preventDefault();
        return false;
    });

    // Como taraflı kupon kullanımı için bilgi veren modal'ı açan event
    // Kullanıcı kuponu seçtikten sonra değiştirme yapamayacak ve seçilen bu kupon kullanılması gerekecek,
    // eğer kupon seçildikten sonra kullanılmazsa belirli bir süre tekrardan seçilemeyecek şekilde kalmaktadır(Como tarafında).
    //$("body .UseComoCouponIdOpenModal").click(function (e) {
    //    var couponCode = $(this).attr("data-couponKey");
    //    // Buton'dan alınan attribute değerleri modal'a atanıyor
    //    $("#ComoCouponModal #UseComoCouponId").attr("data-couponKey", couponCode);

    //    var modelDescription = $(this).attr("data-modal-description"); // Modal'da gösterilecek olan açıklamanın alınması
    //    $("#ComoCouponModal .modal-body").html(modelDescription); // Modal'a açıklamının basılması

    //    $("#ComoCouponModal #UseComoCouponId").show();
    //    $("#ComoCouponModal .RemoveComoCoupon").hide();

    //    //$("#ComoCouponModal").modal(); // modal'ı kod ile açmak için
    //});

    //// Como kuponunu kullanmak için backend tarafına istek yapılması
    //$("#ComoCouponModal #UseComoCouponId").click(function (e) {
    //    var couponCode = $(this).attr("data-couponKey");

    //    UseCoupon(couponCode, true); // 'true' ile Como kuponu olmadığı belirtilmiş oluyor

    //    $("#ComoCouponModal .close").click(); // açık olan modal'ın kod ile kapatılması

    //    e.preventDefault();
    //    return false;
    //});

    // Site taraflı kupon silme
    $("body").on("click", ".RemoveCoupon", function (e) {
        RemoveCoupon();
        e.preventDefault();

        return false;
    });

    // Como taraflı kupon silmek için backend tarafına istek yapılması
    $("#ComoCouponModal .RemoveComoCoupon").click(function (e) {
        RemoveCoupon(); // Site taraflı ve Como taraflı olan kupon varsa silinmek için istek yapılıyor

        $("#ComoCouponModal .close").click(); // açık olan modal'ın kod ile kapatılması

        e.preventDefault();
        return false;
    });
    //#endregion END COUPON Functions

    //Adress Create And Edit
    $("body").on("click", ".AdresPopup", function () {

        var url = $(this).attr("data-href");

        GetAddressForm(url);

    });

    $("#OrderAdress").on("click", ".RemoveIcon", function () {

        $(this).closest("tr").css("opacity", "0.5");
        var id = $(this).attr("data-id");

        var url = "/" + $("#SmallLangCode").val() + "/p/" + CheckOutAddressPath + "/Delete?adresid=" + id;

        $.ajax({
            type: 'post',
            url: url,
            dataType: 'json',
            success: function (data) {
                ReloadOnTimeOut(data);

                if (data.Status == true) {
                    $("#OpStatusBar div.alert-success ul li").html(data.ResultDescription[0]);
                    $("#OpStatusBar > div.alert-sucess ").show();

                    ReloadPage();

                }
                else {
                    SetErrorResults($("#OpStatusBar div.alert-danger ul li"), data.ResultDescription, true, false);
                    $("#OpStatusBar > div.alert-danger ").show();
                }

            },
            error: function (data) {
                $("#Errors .alert-error").html(data.ResultDescription[0]);
            }
        });

    });

    $("body").on("change", ".ddl_ulke", function () {

        var seciliUlkeID = $(this).val();
        $(".ajaxilce").show();

        $.ajax({
            type: 'get',
            url: '/User/GetCities',
            data: 'countryid=' + seciliUlkeID,
            dataType: 'json',
            success: function (dt) {

                var icerik = "";

                $('#CityID option').remove();
                $('.ddl_sehir option').remove();
                $('.ddl_ilce option').remove();
                $('.ddl_mahalle option').remove();

                $('#CityID')
                    .append($("<option selected='selected'></option>")
                        .attr("value", "")
                        .text("Lütfen Seçin"));


                $('#CityID').parent().find("span").html("Lütfen Seçin");

                for (var i = 0; i < dt.length; i++) {
                    $('#CityID')
                        .append($("<option></option>")
                            .attr("value", dt[i].ID)
                            .text(dt[i].Name));
                }

                $(".ajaxilce").hide();


            }
        });

        RefReshCityAndTowns();
    });

    $("body").on("change", ".ddl_sehir", function () {

        var seciliSehirOID = $(this).val();
        $(".ajaxilce").show();

        $.ajax({
            type: 'get',
            url: '/User/GetTowns',
            data: 'cityid=' + seciliSehirOID,
            dataType: 'json',
            success: function (dt) {
                var icerik = "";
                $('#TownID option').remove();

                $('#TownID')
                    .append($("<option selected='selected' ></option>")
                        .attr("value", "")
                        .text("Lütfen Seçin"));


                $('#TownID').parent().find("span").html("Lütfen Seçin");

                for (var i = 0; i < dt.length; i++) {

                    $('#TownID')
                        .append($("<option></option>")
                            .attr("value", dt[i].ID)
                            .text(dt[i].Name));
                }

                $(".ajaxilce").hide();

            }
        });
    });

    $("body").on("change", ".ddl_ilce", function () {

        var seciliIlceID = $(this).val();
        $(".ajaxilce").show();

        $.ajax({
            type: 'get',
            url: '/User/GetQuarters',
            data: 'TownID=' + seciliIlceID,
            dataType: 'json',
            success: function (dt) {

                var icerik = "";
                $('#QuarterID option').remove();

                $('#QuarterID')
                    .append($("<option selected='selected' ></option>")
                        .attr("value", "")
                        .text("Lütfen Seçin"));

                $('#QuarterID').parent().find("span").html("Lütfen Seçin");

                for (var i = 0; i < dt.length; i++) {
                    $('#QuarterID')
                        .append($("<option></option>")
                            .attr("value", dt[i].ID)
                            .text(dt[i].Name));
                }

                $(".ajaxilce").hide();
            }
        });
    });

    $("#AddressArea").on("submit", "form.OrderAdressForm", function (e) {

        $form = $(this);
        $("#OpStatusBar div").hide();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            cache: false,
            success: function (data) {
                ReloadOnTimeOut(data);

                if (data.Status == true) {

                    $("#OpStatusBar div.alert-success ul li").html(data.ResultDescription[0]);
                    $("#OpStatusBar > div.alert-sucess ").show();

                    $(".AjaxLoader").show();
                    $(".container").css("opacity", "0.5");

                    document.location.reload(true);
                }
                else {
                    SetErrorResults($("#OpStatusBar div.alert-danger ul li"), data.ResultDescription, true, false);
                    $("#OpStatusBar > div.alert-danger ").show();
                }
            },
            error: function (data) {
                $("#Errors .alert-error").html(data.ResultDescription[0]);
            }

        });

        e.preventDefault();
        return false;
    });

    var deliverCheckedVal = 0;
    var billingCheckedVal = 0;

    if ($("#OrderAdress input[name=adr_del]:checked").length > 0) {
        deliverCheckedVal = $("#OrderAdress input[name=adr_del]:checked").val();
    }

    if ($("#OrderAdress input[name=adr_bil]:checked").length > 0) {

        billingCheckedVal = $("#OrderAdress input[name=adr_bil]:checked").val();
    }

    //SetAdres
    $("#OrderAdress").on("change", "input[type=radio]", function (e) {

        var adrtype = $(this).attr("data-adrtype");
        var id = $(this).val();
        $clicked = $(this);

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/" + CheckOutAddressPath + "/SetAddress?addressID=" + id + "&addressType=" + adrtype,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status) {

                    //Sipariş özetini Yenile
                    RefreshOrderSummary(false, false);
                    //KargoListesini Yenile 

                    if (adrtype == "Delivery") {
                        RefreshCargoList();
                    }

                    $("#AddressArea").html("");
                }

                if (dt.Status == false && dt.StatusText == "InvalidAddress" && $("#AddressArea").length > 0) {

                    var url = "/" + $("#SmallLangCode").val() + "/p/" + CheckOutAddressPath + "/EditOrCreate?id=" + id;

                    GetAddressForm(url);

                } else if (dt.Status == false) {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                }

                if (dt.Status == false) {

                    //Remove Checked Status Before go
                    if (adrtype == "Delivery") {

                        $("#OrderAdress input[name=adr_del]").removeAttr("checked");
                        $("#OrderAdress input[name=adr_del][value=" + deliverCheckedVal + "]").prop("checked", "checked");

                    } else if (adrtype == "Billing") {

                        $("#OrderAdress input[name=adr_bil]").removeAttr("checked");
                        $("#OrderAdress input[name=adr_bil][value=" + billingCheckedVal + "]").prop("checked", "checked");
                    }
                }
                else {

                    if (adrtype == "Delivery") {
                        deliverCheckedVal = id;

                    } else if (adrtype == "Billing") {
                        billingCheckedVal = id;

                    }
                }
            }
        });
    });

    //SetKargo
    var selectedCargoPriceID = 0;

    if ($("#CargoTable input:checked").length > 0) {
        selectedCargoPriceID = $("#CargoTable input:checked").val();
    }

    //$("body").on("click", "#OrderAdress td", function () {

    //    $lbl = $(this).find("label");

    //    if ($lbl.length <= 0) {

    //        $(this).closest("tr").find("label").trigger("click");
    //    } 
    //});

    $("body").on("click", "#CargoTable td", function () {

        $lbl = $(this).find("label");

        if ($lbl.length <= 0) {

            $(this).closest("tr").find("label").trigger("click");
        }
    });

    //$("#OrderDetailArea .OrderContentDetails #OrderNote").on("change", "input", function () {
    //    var isCheck = $(this).is(":checked");
    //    if (isCheck != undefined && isCheck === true) {
    //        $(".OrderNote").show();
    //    } else {
    //        $(".OrderNote").hide();
    //    }
    //});

    $(document).on("change", "#OrderDetailArea .OrderContentDetails #OrderNote #OrderNoteChk", function () {
        $(".OrderNote").slideToggle();
    });

    $("#GiftTable").on("change", "input", function () {

        var wantGift = $(this).is(":checked");

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutCart/SetGift?wantGift=" + wantGift,
            success: function (dt) {

                if (wantGift != undefined && wantGift === true) {
                    $(".OrderGiftNote").show();
                }
                else {
                    $(".OrderGiftNote").hide();
                }

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    RefreshOrderSummary();

                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                    $("#GiftTable input").removeProp("checked");
                    $("#GiftTable input[value=" + selectedCargoPriceID + "]").prop("checked", "checked");
                }
            }

        });

    });

    $("body").on("click", "#GiftTable td:not(.RadioTd)", function (e) {

        $radinput = $(this).closest("tr").find("input:first");
        $radinput.prop("checked", !$radinput.is(":checked"));
        $(this).closest("tr").find("input").trigger("change");

    });

    $("body").on("change", "#PaymentGroups input, .WebPosItem input, #BankList input", function (e) {

        $label = $(this).closest("label");
        $input = $(this);

        var paymentType = $input.attr("data-payment");
        var paymentTypeValue = $input.val();

        var webposinstallmentid = $input.attr("data-webposinstallment-id");
        var bankid = $input.attr("data-bankid");

        $("#PaymentGroups input").removeProp("checked");
        $("#PaymentGroups label, .TaksitLabel").removeClass("active");

        $label2 = $("#PaymentGroups label input[data-payment='" + paymentType + "']:first").closest("label");


        $label.addClass("active");
        $label2.addClass("active");

        $label.find("input").prop("checked", "checked");



        $(".PaymentDetail").removeClass("active");
        $(".PaymentDetail." + paymentType).addClass("active");

        if ($(this).closest("#PaymentGroups").length > 0) {

            $("#Erros").html("");
            $("#Erros").hide();
            $(".WebPosItem").hide();

            var webPosId = $(".WebPosItem.active").attr("data-webposid");

            $(".WebPosItem[data-webposid='" + webPosId + "']").show();
            //$(".WebPosItem[data-cardtype='" + paymentType + "']").show();


        }

        SetPaymentType(webposinstallmentid, bankid);

    });

    $("body").on("click", ".PosGroupItem", function (e) {
        $(".PosGroupItem").removeClass("active");
        $(this).addClass("active");
        var webPosId = $(this).attr("data-webposid");

        $(".WebPosItem").hide();
        $(".WebPosItem[data-webposid='" + webPosId + "']").show();

    });

    $("body").on("keyup", "#CardNumbers input", function (e) {

        var cr_1 = $("#CardNumbers > input#CardNumber1").val().replace(/\D/g, '');
        cr_1 = formatCC(cr_1);
        $("#CardNumbers > input#CardNumber1").val(cr_1);

        var cardNumber = cr_1.replace(/\D/g, '');

        isAllValid = false;

        if (cardNumber.length == 16 && validateCardNumber(cardNumber) == false) {

            $("#CardNumbers > input").addClass("NotValid");
            isAllValid = false;

        } else {
            $("#CardNumbers > input").removeClass("NotValid");
            isAllValid = true;
        }


        if (IsNumeric($(this).val().replace(/\D/g, '')) == false && $(this).val() != "" && $(this).hasClass("cardno")) {

            $(this).addClass("NotValid");
        }
        else {

            if (isAllValid || cardNumber.length < 16 || !$(this).hasClass("cardno")) {
                $(this).removeClass("NotValid");
            }

            if (isAllValid) {
                $("#CardNumbers > input").removeClass("NotValid");
            }
        }


        CheckBinNumber();

        //if ($(this).attr("id") == "CardOwner" && IsNumeric($(this).val().replace(/\D/g, ''))) {

        //    $(this).addClass("NotValid");
        //    $(".CardOwnerHeader").addClass("MoveNeeded");
        //}
        //else if ($(this).attr("id") == "CardOwner") {

        //    $(this).removeClass("NotValid");
        //    $(".CardOwnerHeader").removeClass("MoveNeeded");

        //}

    });

    $("body").on("change", "#CardForm .ExpiresMonth, #CardForm .ExpiresYear", function (e) {

        CheckBinNumer();
    });

    $("#CargoTable").on("change", "input", function () {

        var id = $(this).val();
        $clicked = $(this);

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutAddress/SetCargoPrice?cargoPriceID=" + id,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    RefreshOrderSummary();
                    selectedCargoPriceID = id;

                }
                else {


                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                    $("#CargoTable input").removeProp("checked");
                    $("#CargoTable input[value=" + selectedCargoPriceID + "]").prop("checked", "checked");

                }
            }

        });

    });

    $("body").on("change", "#AggrementApprove", function () {

        var IsApproved = $(this).is(":checked");

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/SetAgreement?isApproved=" + IsApproved,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    RefreshOrderSummary();

                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                }
            }

        });

    });

    $("body").on("change", ".GirogateOdemeTuru > li > a  > input", function () {

        $GirogatePaymentType = $(this).val();

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/SetGirogatePaymentType?girogateOdemeTuru=" + $GirogatePaymentType,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    RefreshOrderSummary();

                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                }
            }

        });

    });

    $("body").on("change", "#PaymentWith3D", function () {

        var IsApproved = $(this).is(":checked");

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/Set3dPayment?isApproved=" + IsApproved,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    RefreshOrderSummary();

                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                }
            }

        });

    });

    //#region LOGIN & REGISTER
    var UseTagManager = false;
    $("body").on("submit", "form.UyeGiris", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {

                        AddUserAction("Login");
                    }

                    if (dt.JsonRs == "Reload") {

                        $("#AlertResult").removeClass("alert-danger");
                        $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                        $(".AjaxLoader").show();
                        $form.hide();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();

                    }

                    if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = dt.Deger5;
                    }

                    $("#AlertResult").removeClass("alert-danger");

                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }


                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $("body").on("submit", "form.UyeOl", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {
                        AddUserAction("Signup");
                    }

                    if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = "/";
                    }

                    if (dt.JsonRs == "Reload") {

                        $form.hide();

                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();
                    }

                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").hide();
                    //$("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);



                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }

                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $("body.CheckOut").on("click", "a.RegisterIcon, a.LoginIcon, #CheckoutHeader .RegisterIcon a, #CheckoutHeader  .LoginIcon a, #CheckoutHeader  a.RegisterIcon , #CheckoutHeader  a.LoginIcon", function (e) {

        $("#LoginRegisterModal").modal('show');

        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

            var swparams = GetSwPageParams();
            swparams = ChangeSwHashedStringParamValue(swparams, "ActionType", "SiparisUyelikPopupAcma");
            AddSwAction(swparams);

        }

        if (UseTagManager) {
            AddCheckOutView('', 2);
            SendGaDataLayerVirtual();
        }

        if ($(this).closest("li").hasClass("RegisterIcon") || $(this).hasClass("RegisterIcon")) {

            if ($(".UyeKayitCol").hasClass("pull-right") == false) {

                $(".RegisterInBanner").trigger("click");
            }

        }
        else {
            if ($(".UyeKayitCol").hasClass("pull-right")) {

                $(".RegisterInBanner").trigger("click");
            }
        }

        e.preventDefault();
        return false;
    });

    $("body").on("click", "#ReadAgreement", function (e) {

        $("#AgreementModal .modal-body").html($("#AgreementDetails").html() + $("#OnBilgilendirmetails").html());
        $("#AgreementModal").modal('show');

        return false;
    });

    $("#UserWelcome").on("click", "a.Popup", function (e) {

        $("#LoginRegisterModal").modal('show');

        e.preventDefault();
        return false;
    });

    $("body .LogRegTabs").on("click", "li.tb", function (e) {

        var target = $(this).attr("data-target");

        $(".Tab1, .Tab2").hide();
        $("." + target).show();

        $(".LogRegTabs li").removeClass("active");
        $(this).addClass("active");

        e.preventDefault();
        return false;
    });

    $("body").on("click", ".ForgetPass", function (e) {

        $("#forgottenpassModal").modal('show');

    });

    $("body").on("submit", "form.ForgettenForm", function () {

        $form = $("form.ForgettenForm");

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (dta) {

                if (dta.Sonuc == true) {

                    $(".ForgettenForm p:first").html(dta.IslemSonucAciklama);

                    $("#email").hide();
                    $("#forgottenPassSubmit").hide();

                    $(".ForgettenForm p:first").removeClass("alert-danger");
                    $(".ForgettenForm p:first").addClass("alert alert-success");

                }
                else {

                    $(".ForgettenForm p:first").html(dta.IslemSonucAciklama);
                    $(".ForgettenForm p:first").addClass("alert alert-danger");
                }



            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $("body").on("change", ".adrestipradio", function () {

        if ($("#AdresTipi2").is(":checked")) {
            $(".vergi").show("slow");
            $(".bireyselFatura").hide("slow");

        }
        else {
            $(".vergi").hide("slow");
            $(".bireyselFatura").show("slow");

        }

        //if ($("#AdresTipi3").is(":checked")) {
        //    $(".bireyselFatura").show("slow");
        //} else {
        //    $(".bireyselFatura").hide("slow");

        //}

    });

    $("#TcNo").mask("99999999999", {
        translation: {
            'Z': {
                pattern: /[0-9]/, optional: true
            }
        }
    });

    $("#register_Gsm").mask("999 999 99 99", {
        translation: {
            'Z': {
                pattern: /[0-9]/, optional: true
            }
        }
    });

    if ($("#register_Gsm").length > 0) {
        $(document).on("keyup", "#register_Gsm", function () {
            var phone = $(this).val();
            var firstChar = phone.substr(0, 1);

            if (firstChar != "5" && phone.length > 1) {
                $(this).val("");
            }
            else if (firstChar != "5") {
                phone = phone.substr(1, phone.length);
                $(this).val(phone);
            }
        });
    }

    // Özel karakter kısıtı
    //$("#OrderNoteText").keydown(function (e) {
    //    var test = /^[a-zA-ZğüşöçİĞÜŞÖÇ0-9.,;'":/\-*&!?$@%()\[\]<>+~#_ ]+$/; //regex
    //    var value = String.fromCharCode(e.keyCode); //get the charcode and convert to char
    //    if (!value.match(test)) {
    //        return false; //dont display key if it is a number
    //    }
    //});

    $("#OrderGiftNoteText").keydown(function (e) {
        var test = [A-Za-z0-9]; //regex
        var value = String.fromCharCode(e.keyCode); //get the charcode and convert to char

        if (!value.match(test)) {
            return false; //dont display key if it is a number
        }
    });

    //#region JKMoneyPuan Functions
    $(document).on("submit", ".SummaryContainer #JKMoneyPuanForm", function () {
        var JKMoneyPuanAmount = $(this).find("#JKMoneyPuanInput").val();
        UseJKMoneyPuan(JKMoneyPuanAmount); // 'false' ile Como kuponu olmadığı belirtilmiş oluyor

        return false;
    });

    $(document).on("click", "#OrderSummary .OrderJKMoneyPuan.UsedJKMoneyPuan button#RemoveJKMoneyPuan", function () {
        RemoveJKMoneyPuan();
    });

    // JKMoneyPuan silme
    $("body").on("click", "#RemoveJKMoneyPuan", function (e) {
        RemoveJKMoneyPuan();
        e.preventDefault();

        return false;
    });
    //#endregion END JKMoneyPuan Functions
});
